"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDate = exports.formatDate = exports.default = exports.DEFAULT_DATE_FORMAT = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _recompose = require("recompose");
var _reactDatetime = _interopRequireDefault(require("react-datetime"));
require("react-datetime/css/react-datetime.css");
var _classnames = _interopRequireDefault(require("classnames"));
var _error = require("@catalytic/catalytic-icons/lib/icons/error.svg");
var _Text = require("../../Text/Text");
var _colors = require("../../style/colors");
var _injectSheet = _interopRequireDefault(require("../../style/injectSheet"));
var _InputRequired = _interopRequireDefault(require("../InputRequired/InputRequired"));
var _ModalView = require("../../View/ModalView/ModalView");
var _excluded = ["className", "disabled", "embedded", "hasRequired", "inputClassName", "inputRef", "name", "readOnly", "required", "value"],
  _excluded2 = ["classes", "className", "closeOnSelect", "colorScheme", "dateFormat", "dateTimeRef", "defaultValue", "disabled", "displayErrors", "hasError", "hasSuccess", "hasValidation", "inputClassName", "intl", "isValidDate", "locale", "modalViewContext", "name", "onBlur", "onChange", "readOnly", "required", "setDisplayErrorsState", "setLoadingState", "theme", "timeFormat", "title", "utc"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /*:: // 

import { type ComponentType, type ElementRef } from 'react';*/ /*:: import type {
  InjectSheetProvidedProps,
  ThemeType
} from '../../style/ThemeTypes';*/
var DEFAULT_DATE_FORMAT = exports.DEFAULT_DATE_FORMAT = 'YYYY-MM-DD';
var DEFAULT_VALUE = '';
var DISPLAY_NAME = 'DateTimeInput';
var NOOP = function NOOP() {};
var formatDate = exports.formatDate = function formatDate(value /*: string*/, format /*: boolean*/) /*: string*/{
  var _ref = format ? [value] : value.split('T'),
    _ref2 = (0, _slicedToArray2.default)(_ref, 1),
    date = _ref2[0];
  return date;
};
var getDate = exports.getDate = function getDate(value /*: string*/) /*: string*/{
  var date = new Date(value);

  // Detect an invalid date.
  // https://stackoverflow.com/a/1353711
  return value && Object.prototype.toString.call(date) === '[object Date]' && !isNaN(date) ? date.toISOString() : DEFAULT_VALUE;
};
var messages = {
  error: {
    defaultMessage: 'Invalid Date',
    id: 'datetime.error'
  }
};
var definedMessages = (0, _reactIntl.defineMessages)(messages);
var Style = function Style(theme /*: ThemeType*/) {
  var keys = Object.keys(_colors.COLORS);
  var ACTIVE_COLOR = theme.colors.black;

  // https://github.com/YouCanBookMe/react-datetime/blob/master/css/react-datetime.css
  return {
    root: {
      '@global': {
        'table, thead, tbody, tfoot, tr, th, td': {
          verticalAlign: 'middle'
        }
      },
      position: 'relative',
      '& .rdtPicker': {
        background: theme.colors.white,
        borderColor: theme.colors.blueGrey,
        boxShadow: "0 .25rem .5rem ".concat(theme.colors.pastelGreyAlpha),
        zIndex: function zIndex(_ref3) {
          var modalViewContext = _ref3.modalViewContext;
          return "".concat(modalViewContext ? theme.zIndex.modal : theme.zIndex.menu, " !important");
        }
      },
      '& .rdtPicker td.rdtDay:hover, & .rdtPicker td.rdtHour:hover, & .rdtPicker td.rdtMinute:hover, & .rdtPicker td.rdtSecond:hover, & .rdtPicker .rdtTimeToggle:hover': {
        background: theme.colors.lightGrey
      },
      '& .rdtPicker td.rdtOld, & .rdtPicker td.rdtNew': {
        color: theme.colors.battleshipGrey
      },
      '& .rdtPicker td.rdtToday:before': {
        borderBottomColor: ACTIVE_COLOR
      },
      '& .rdtPicker td.rdtActive, & .rdtPicker td.rdtActive:hover': {
        backgroundColor: ACTIVE_COLOR,
        color: theme.colors.white,
        textShadow: 'none'
      },
      '& .rdtPicker td.rdtActive.rdtToday:before': {
        borderBottomColor: theme.colors.white
      },
      '& .rdtPicker td.rdtDisabled, & .rdtPicker td.rdtDisabled:hover': {
        color: theme.colors.battleshipGrey
      },
      '& .rdtPicker td span.rdtOld': {
        color: theme.colors.battleshipGrey
      },
      '& .rdtPicker td span.rdtDisabled, & .rdtPicker td span.rdtDisabled:hover': {
        color: theme.colors.battleshipGrey
      },
      '& .rdtPicker th': {
        borderBottomColor: theme.colors.white
      },
      '& .rdtPicker th.rdtDisabled, & .rdtPicker th.rdtDisabled:hover': {
        color: theme.colors.battleshipGrey
      },
      '& .rdtPicker thead tr:first-child th:hover': {
        background: theme.colors.lightGrey
      },
      '& .rdtPicker tfoot': {
        borderTopColor: theme.colors.white
      },
      '& .rdtPicker button:hover': {
        backgroundColor: theme.colors.lightGrey
      },
      '& td.rdtMonth:hover, & td.rdtYear:hover': {
        background: theme.colors.lightGrey
      },
      '& .rdtCounter .rdtBtn:hover': {
        background: theme.colors.lightGrey
      }
    },
    input: theme.mixins.inputStyle,
    readOnly: {
      '&[readonly]': {
        '&, &:focus, &:hover': theme.mixins.inputReadOnly
      }
    },
    disabled: {
      '&:disabled': {
        '&, &:focus, &:hover': theme.mixins.inputDisabled
      }
    },
    success: theme.mixins.inputSuccess,
    error: theme.mixins.inputError,
    errorMessage: theme.mixins.inputInlineErrorMessage,
    errorIcon: theme.mixins.inputInlineErrorIcon,
    container: {
      position: 'relative'
    },
    required: {},
    inputShadow: {
      display: 'none',
      '&:required:valid': {
        '& ~ $required': {
          display: 'none'
        }
      }
    },
    colorScheme: keys.reduce(function (accumulator, color) {
      var hex = _colors.COLORS[color];
      return _objectSpread(_objectSpread({}, accumulator), {}, (0, _defineProperty2.default)({}, "&[data-color=\"".concat(color, "\"]"), {
        '& .rdtPicker td.rdtToday:before': {
          borderBottomColor: hex
        },
        '& .rdtPicker td.rdtActive, & .rdtPicker td.rdtActive:hover': {
          backgroundColor: hex
        }
      }));
    }, {}),
    embeddedInput: theme.mixins.inputEmbedded
  };
};
/*:: export type DateTimeInputType = InjectSheetProvidedProps &
  HTMLInputElement & {
    closeOnSelect: boolean,
    colorScheme?: string,
    /*
    | Moment.js   | Intl.DateTimeFormat                                     | en-US             | de-DE            |
    |-----------  |-------------------------------------------------------  |-----------------  |----------------  |
    | YYYY-MM-DD  |                                                         | 2020-01-01        |                  |
    | l           | { year: 'numeric', month: 'numeric', day: 'numeric' }   | 1/1/2020          | 1.1.2020         |
    | L           | { year: 'numeric', month: '2-digit', day: '2-digit' }   | 01/01/2020        | 01.01.2020       |
    | ll          | { year: 'numeric', month: 'short', day: 'numeric' }     | Jan 1, 2020       | 1. Jan. 2020     |
    | LL          | { year: 'numeric', month: 'long', day: 'numeric' }      | January 1, 2020   | 1. Januar 2020   |
    *-/
    dateFormat?: 'YYYY-MM-DD' | 'l' | 'L' | 'll' | 'LL',
    dateTimeRef?: ElementRef<*>,
    displayErrors: boolean,
    embedded?: boolean,
    hasError: boolean,
    hasRequired: boolean,
    hasSuccess: boolean,
    hasValidation?: boolean,
    inputClassName?: string,
    inputRef?: ElementRef<*>,
    intl: Object,
    isValidDate?: (current: any, selected: any) => boolean,
    locale?: string,
    modalViewContext: boolean,
    onBlur?: ({
      currentTarget: { id: string, name: string, value: any }
    }) => mixed,
    onChange?: ({
      currentTarget: { id: string, name: string, value: any }
    }) => mixed,
    setDisplayErrorsState?: (displayErrors: boolean) => mixed,
    setLoadingState?: (loading: boolean) => mixed,
    /*
    | Moment.js   | Intl.DateTimeFormat                                     | en-US             | de-DE            |
    |-----------  |-------------------------------------------------------  |-----------------  |----------------  |
    | h:mm A      | { hour: 'numeric', minute: 'numeric', hour12: true }    | 1:30 PM           |                  |
    | HH:mm       | { hour: 'numeric', minute: 'numeric', hour12: true }    | 13:30             |                  |
    *-/
    timeFormat?: false | 'h:mm A' | 'HH:mm',
    utc: boolean
  };*/
/*:: type State = {
  defaultValue: string
};*/
var DateTimeInput = /*#__PURE__*/function (_PureComponent) {
  function DateTimeInput() {
    var _this;
    (0, _classCallCheck2.default)(this, DateTimeInput);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, DateTimeInput, [].concat(args));
    (0, _defineProperty2.default)(_this, "state", {
      defaultValue: getDate(_this.props.defaultValue)
    });
    (0, _defineProperty2.default)(_this, "handleBlur", function () {
      var _this$props = _this.props,
        id = _this$props.id,
        name = _this$props.name,
        onBlur = _this$props.onBlur,
        timeFormat = _this$props.timeFormat;
      var defaultValue = _this.state.defaultValue;
      if (onBlur) {
        var formattedDefaultValue = formatDate(defaultValue, Boolean(timeFormat));
        return onBlur({
          currentTarget: {
            id: id,
            name: name,
            value: formattedDefaultValue
          }
        });
      }
    });
    (0, _defineProperty2.default)(_this, "handleChange", function (value /*: string*/) {
      var _this$props2 = _this.props,
        id = _this$props2.id,
        name = _this$props2.name,
        onChange = _this$props2.onChange,
        timeFormat = _this$props2.timeFormat;
      var defaultValue = getDate(value);
      _this.setState({
        defaultValue: defaultValue
      });
      if (onChange) {
        var formattedDefaultValue = formatDate(defaultValue, Boolean(timeFormat));
        return onChange({
          currentTarget: {
            id: id,
            name: name,
            value: formattedDefaultValue
          }
        });
      }
    });
    (0, _defineProperty2.default)(_this, "renderInput", function (_ref4 /*:: */) {
      var className = _ref4 /*:: */.className,
        disabled = _ref4 /*:: */.disabled,
        embedded = _ref4 /*:: */.embedded,
        hasRequired = _ref4 /*:: */.hasRequired,
        inputClassName = _ref4 /*:: */.inputClassName,
        ref = _ref4 /*:: */.inputRef,
        name = _ref4 /*:: */.name,
        readOnly = _ref4 /*:: */.readOnly,
        required = _ref4 /*:: */.required,
        value = _ref4 /*:: */.value,
        props = (0, _objectWithoutProperties2.default)(_ref4 /*:: */, _excluded);
      var _this$props3 = _this.props,
        classes = _this$props3.classes,
        intl = _this$props3.intl,
        timeFormat = _this$props3.timeFormat;
      var defaultValueProp = _this.state.defaultValue;
      var defaultValue = formatDate(defaultValueProp, Boolean(timeFormat));
      var hasError = value && !defaultValue;
      if (ref && (0, _typeof2.default)(ref) === 'object' && ref.current && (0, _typeof2.default)(ref.current) === 'object' && typeof ref.current.setCustomValidity === 'function') {
        ref.current.setCustomValidity(hasError ? intl.formatMessage(definedMessages.error) : '');
      }
      return /*#__PURE__*/_react.default.createElement("div", {
        className: classes.container
      }, /*#__PURE__*/_react.default.createElement("input", (0, _extends2.default)({
        className: (0, _classnames.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, classes.error, hasError), classes.embeddedInput, embedded), classes.readOnly, readOnly), classes.disabled, disabled), className),
        "data-testid": name || 'date-time-input',
        disabled: disabled,
        readOnly: readOnly,
        ref: ref,
        value: value
      }, props)), /*#__PURE__*/_react.default.createElement("input", {
        className: classes.inputShadow,
        "data-name": name,
        name: name,
        onChange: NOOP,
        required: required,
        value: defaultValue
      }), !hasError && /*#__PURE__*/_react.default.createElement(_InputRequired.default, {
        className: classes.required,
        disabled: disabled,
        hasRequired: hasRequired,
        readOnly: readOnly,
        required: required
      }), hasError && !embedded && /*#__PURE__*/_react.default.createElement("div", {
        className: classes.errorMessage,
        "data-id": "".concat(DISPLAY_NAME, "__indicators")
      }, /*#__PURE__*/_react.default.createElement(_Text.ExtraSmallText, null, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, messages.error)), /*#__PURE__*/_react.default.createElement(_error.ReactComponent, {
        className: classes.errorIcon
      })));
    });
    return _this;
  }
  (0, _inherits2.default)(DateTimeInput, _PureComponent);
  return (0, _createClass2.default)(DateTimeInput, [{
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
        classes = _this$props4.classes,
        className = _this$props4.className,
        closeOnSelect = _this$props4.closeOnSelect,
        colorScheme = _this$props4.colorScheme,
        dateFormat = _this$props4.dateFormat,
        dateTimeRef = _this$props4.dateTimeRef,
        defaultValueProp = _this$props4.defaultValue,
        disabled = _this$props4.disabled,
        displayErrors = _this$props4.displayErrors,
        hasError = _this$props4.hasError,
        hasSuccess = _this$props4.hasSuccess,
        hasValidation = _this$props4.hasValidation,
        inputClassName = _this$props4.inputClassName,
        intl = _this$props4.intl,
        isValidDate = _this$props4.isValidDate,
        locale = _this$props4.locale,
        modalViewContext = _this$props4.modalViewContext,
        name = _this$props4.name,
        onBlur = _this$props4.onBlur,
        onChange = _this$props4.onChange,
        readOnly = _this$props4.readOnly,
        required = _this$props4.required,
        setDisplayErrorsState = _this$props4.setDisplayErrorsState,
        setLoadingState = _this$props4.setLoadingState,
        theme = _this$props4.theme,
        timeFormat = _this$props4.timeFormat,
        title = _this$props4.title,
        utc = _this$props4.utc,
        props = (0, _objectWithoutProperties2.default)(_this$props4, _excluded2);
      var defaultValue = this.state.defaultValue;
      var hasValue = defaultValue && defaultValue.length > 0;
      var isRequired = required && !hasValue;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)(classes.root, classes.colorScheme, className),
        "data-color": colorScheme || undefined,
        tabIndex: "-1",
        title: title
      }, /*#__PURE__*/_react.default.createElement(_reactDatetime.default, {
        closeOnSelect: closeOnSelect,
        dateFormat: dateFormat,
        defaultValue: defaultValue ? new Date(defaultValue) : undefined,
        inputProps: _objectSpread({
          'data-name': name,
          disabled: disabled || readOnly,
          className: (0, _classnames.default)(classes.input, (0, _defineProperty2.default)((0, _defineProperty2.default)({}, classes.success, hasSuccess || displayErrors && !isRequired), classes.error, hasError || displayErrors && isRequired), inputClassName),
          name: name,
          readOnly: readOnly,
          required: required
        }, props),
        isValidDate: isValidDate,
        locale: locale,
        onBlur: this.handleBlur,
        onChange: this.handleChange,
        ref: dateTimeRef,
        renderInput: this.renderInput,
        timeFormat: timeFormat,
        utc: utc || !timeFormat
      }));
    }
  }]);
}(_react.PureComponent); // TODO: Type props to EnhancedDateTimeIput component
(0, _defineProperty2.default)(DateTimeInput, "displayName", DISPLAY_NAME);
(0, _defineProperty2.default)(DateTimeInput, "defaultProps", {
  autoComplete: 'off',
  closeOnSelect: false,
  // https://github.com/YouCanBookMe/react-datetime/issues/550,
  colorScheme: _colors.SCIENCE_BLUE,
  dateFormat: DEFAULT_DATE_FORMAT,
  disabled: false,
  embedded: false,
  hasError: false,
  hasRequired: true,
  hasSuccess: false,
  isValidDate: function isValidDate() {
    return true;
  },
  readOnly: false,
  required: false,
  timeFormat: true,
  utc: false
});
/*:: type EnhancedProps = Object;*/
var EnhancedDateTimeIput /*: ComponentType<EnhancedProps>*/ = (0, _recompose.compose)((0, _recompose.setDisplayName)(DISPLAY_NAME), _ModalView.withModalViewContext, _reactIntl.injectIntl, (0, _injectSheet.default)(Style), (0, _recompose.withProps)(function (_ref5) {
  var dateTimeRef = _ref5.dateTimeRef,
    inputRef = _ref5.inputRef;
  return {
    dateTimeRef: dateTimeRef || (0, _react.createRef)(),
    inputRef: inputRef || (0, _react.createRef)()
  };
}))(DateTimeInput);
var _default = exports.default = EnhancedDateTimeIput;
//# sourceMappingURL=DateTimeInput.js.map